( function( $ ) {

	$( document ).ready( function() {

		/**
		 * Open modal
		 */
		$( '.js--modal-inner' ).on( 'click', '.acf-field[data-name="role"]', function(e){

			// var $target = $( this ).find( 'ul' )

			$( this ).toggleClass( '-active' );

		});

		$( document ).on( 'click', '.js--modal-set-img', function(e){
			
			e.preventDefault();

			var modal_inner = $( '.js--modal-inner' );

			var img = '<img src="' + $( this ).attr( 'data-src' ) + '" />';
			
			modal_inner.html( img );

			$( '.js--modal' ).addClass( 'modal--visible' );

		} );

		$( document ).on( 'click', '.js--modal-set', function(e){

            e.preventDefault();

            var post_type   = $( this ).attr( 'data-post-type' ),
                post_action = $( this ).attr( 'data-post-action' ),
                post_id     = $( this ).attr( 'data-post-id' ),
                modal_title = $( this ).attr( 'data-title' ),
                user_tg = $( this ).attr( 'data-user-tg' ),
                default_tg = $( this ).attr( 'data-default-tg' ),
                modal_inner = $( '.js--modal-inner' );
            
            // Set loading value
            // @TODO: Loader tonen?
            modal_inner.html( 'Laden..' );

            $( '.js--modal' ).addClass( 'modal--visible' );
            $( '.js--modal' ).addClass( 'modal--post-type-' + post_type );
            $( '.js--modal-title' ).html( modal_title );
            
            $.ajax( {
                type: 'POST',
                dataType: 'JSON',
                url: ajax.url,
                data: {
                    action: 'modal_load_form',
                    post_type: post_type,
                    post_action: post_action,
                    post_id: post_id,
					user_tg : user_tg,
					default_tg : default_tg,
                },
                success: function( response ) {

                    var data = response.data;
                    
                    if ( response.success == true ) {

                        modal_inner.html( data.html );

                        acf.doAction('append', modal_inner);

                    } else {

                        modal_inner.html( data.html );

                    }

                }
            } );

        } );


        /**
		 * Close modal
		 */
		$( document ).on( 'click', '.js--modal-close', function(e){

            $( '.js--modal' ).removeClass( 'modal--visible' );

        } );

		$( '.js--modal' ).on( 'change', '.acf-basic-uploader input[type="file"]', function( e ) {

			var file = $( this ).val(),
				$target = $( this ).closest( '.hide-if-value' ),
				message = $( '<span class="added-file">Bestand toegevoegd</span>' );

			if( file ) {

				$target.append( message );

			} else {

				$target.find( '.added-file' ).remove();

			}

		} );


	} );

} ) ( jQuery );